import { Component, ElementRef, Input, OnChanges, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MobileButtonType } from '@app/components/mobile-bar/mobile-bar.component';
import { DropdownBoxComponent } from '@commonComponents/dropdown-box/dropdown-box.component';
import { KeyValue } from '@commonInterfaces/iKeyValue';
import { NgbDropdownModule } from "@ng-bootstrap/ng-bootstrap";
import { ViewGroup, ViewGroupDto } from '@interfaces/HttpClient/CatalogApiCatalogViewModels';
import { ICatalogQueryParams } from '@interfaces/iCatalogRoutingParams';
import { TranslationService } from '@services/translation.service';

@Component({
	changeDetection: ChangeDetectionStrategy.Eager,
	selector: 'app-mobiletabviewer',
	imports: [DropdownBoxComponent, NgbDropdownModule, FormsModule],
	templateUrl: './mobiletabviewer.component.html',
	styleUrl: './mobiletabviewer.component.scss'
})
export class MobiletabviewerComponent implements OnChanges {

	@Input() viewGroupDtos: ViewGroupDto[]
	@Input() queryParams: ICatalogQueryParams;
	@Input() tabs: ViewGroup[];
	@ViewChild("navElement") nav: ElementRef;

	public activeTab: ViewGroup | string;
	public navId = '';
	public dropDownModel: KeyValue[];

	private hiddenTabs: ViewGroup[] = [
		ViewGroup.Error
	];

	constructor(private router: Router, private route: ActivatedRoute, private translationService: TranslationService) { }

	ngOnChanges() {
		this.dropDownModel = this.tabs
			.filter(t => !this.hiddenTabs.includes(t))
			.map(tab => ({
				key: this.translationService.getByKey(this.getTabKey(tab)),
				value: tab
			}));

		this.activeTab = ViewGroup[this.route.snapshot.queryParams["tab"]] ?? this.tabs?.[0];
		this.navId = ViewGroup[this.activeTab];
	}

	public changeRoute(viewGroup: ViewGroup) {
		this.router.navigate([], { relativeTo: this.route, queryParams: { tab: ViewGroup[viewGroup], mobileView: this.getMobileView(viewGroup) }, queryParamsHandling: "merge" });
	}

	public getTabKey(tab: ViewGroup) {
		return "attachments." + ViewGroup[tab];
	}

	private getMobileView(viewGroup: ViewGroup): string {
		const curMobileView = MobileButtonType[this.route.snapshot.queryParams["mobileView"]];
		switch (viewGroup) {
			case ViewGroup.CatalogContactPersons: return MobileButtonType[MobileButtonType.CatalogContact];
			case ViewGroup.CatalogContact:
			case ViewGroup.CatalogInfo: return MobileButtonType[MobileButtonType.CatalogInfo];
			default: return MobileButtonType[curMobileView];
		}
	}
}
